import React, {useCallback, useEffect, useRef, useState} from "react";
import {useHistory, useLocation} from "react-router-dom";
import {
    submitClaim
} from "../api/RestCallHelper";
import {FormButton} from "../styles/globalStyles";
import AutocompleteTextInput, {DataType} from "../shared/AutocompleteTextInput";
import DatePicker from "../shared/DatePicker";
import TextInput from "../shared/TextInput";
import {validateForm} from "../utils/ValidationUtil";
import FormPage from "./baseFormPage/BaseFormPage";
import FormHeader from "../shared/FormHeader";
import {FeedbackReducerActionType, useFeedbackDispatch} from "../utils/FeedbackContext";
import useFetchClaimableMembersDropdown from "../hooks/useFetchClaimableMembersDropdown";

export default () => {

  let location = useLocation();
  let history = useHistory();

    const dispatch = useFeedbackDispatch();

    const [claim, setClaim] = useState({
    id:"",
    amount:"",
    claimDate: null,
    buriedDate:null,
    deathDate:null,
    burialPlace:""
  });

    const [dropdownOpen, setDropdownOpen] = useState(false);
    const [dropdownData, loading] = useFetchClaimableMembersDropdown(dropdownOpen);
    const [formValidated, setFormValidated] = useState(false);
    const [isSending, setIsSending] = useState(false);
    const isMounted = useRef(true);

    const close = (event, reason) => {
        console.log("In ClaimsForm close callback");
        if (reason === 'clickaway') return;

        dispatch({type: FeedbackReducerActionType.CLOSE_FEEDBACK});
    };

  const clear = () => {

    setClaim({
        id:"",
        amount:"",
        claimDate: null,
        buriedDate:null,
        deathDate:null,
        burialPlace:""
    })
  }

  const submit = useCallback(async () => {

    // don't send again while we are sending
    if (isSending) return;

    // update state
    setIsSending(true);

    // send the actual request
    await submitClaim(claim, dispatch, close, history, location);

    // once the request is sent, update state again
    if (isMounted.current){
      // only update if we are still mounted
      setIsSending(false);
      clear();
    }

  }, [isSending, location, isMounted, claim]); // update the callback if the state changes

  useEffect(() => {
    setFormValidated(validateForm(claim));
    console.log("premium", claim);
  }, [claim, formValidated]);

  return (

    <FormPage
      
      header = {
          <FormHeader
              heading="Submit Claim"
          />
      }

      form = {
          <>
            <AutocompleteTextInput
              label = "Select Claimant"
              value = {claim.id}
              onChange = {(value) => setClaim({...claim , id: value})}
              optionsList = {dropdownData}
              loading = {loading}
              open = {dropdownOpen}
              setOpen = {setDropdownOpen}
              dataType = {DataType.CLAIMANT}
            />

            <DatePicker
              label="Death Date"
              value={claim.deathDate}
              onChange={(value) => setClaim({ ...claim, deathDate: value }) }
              style={{ margin: "10px" }}
            />

            <DatePicker
              label="Burial Date"
              value={claim.buriedDate}
              onChange={(value) => setClaim({ ...claim, buriedDate: value }) }
              style={{ margin: "10px" }}
            />

            <DatePicker
              label="Claimed Date"
              value={claim.claimDate}
              onChange={(value) => setClaim({ ...claim, claimDate: value }) }
              style={{ margin: "10px" }}
            />

            <TextInput
              number
              label="Amount"
              value={claim.amount}
              onChange={(value) => setClaim({ ...claim, amount: value }) }
              style={{ margin: "10px" }}
            />

            <TextInput
              label="Burial Place"
              value={claim.burialPlace}
              onChange={(value) => setClaim({ ...claim, burialPlace: value }) }
              style={{ margin: "10px" }}
            />
          </>
      }

      buttons = {
          <>
              {formValidated &&
                  <FormButton
                      disabled={isSending}
                      onClick={submit}
                  >
                      Submit
                  </FormButton>   
              }

              <FormButton
                  onClick={clear}
                  disabled={isSending}
              >
                  Clear
              </FormButton>
          </>
      }
    />
  );
}
